import { ReactNode } from 'react';
import defaultLogo from '../../assets/logo.png';
import clsx from 'clsx';

interface HeaderProps {
  title: string;
  children?: ReactNode;
  hasSidebar?: boolean;
  /**
   * Logo marki (brand):
   *  - `undefined` → domyślne logo MotoControler,
   *  - `null`      → marka jeszcze nieznana: nie pokazujemy logo (rezerwujemy
   *                  miejsce), żeby uniknąć mignięcia złym logiem,
   *  - `string`    → konkretne logo brandu.
   */
  logoSrc?: string | null;
}

export const Header = ({ title, hasSidebar, logoSrc }: HeaderProps) => {
  const isLogoPending = logoSrc === null;
  const resolvedLogoSrc = logoSrc ?? defaultLogo;

  return (
    <header className="bg-white border-b border-primary-50">
      <div className={clsx('container', hasSidebar ? 'py-10' : 'py-4')}>
        <div className="flex justify-between items-center">
          {!hasSidebar && (
            <div className="flex items-center">
              {isLogoPending ? (
                <div
                  aria-hidden
                  className="mr-4 h-[36px] w-auto md:h-[56px] xl:h-[76px]"
                />
              ) : (
                <img
                  src={resolvedLogoSrc}
                  alt="Logo"
                  className="mr-4 h-[36px] w-auto md:h-[56px] xl:h-[76px]"
                />
              )}
            </div>
          )}
          <h1
            className={clsx(
              'ml-auto text-lg font-bold md:text-2xl xl:text-[38px]',
            )}
          >
            {title}
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
